import React from 'react';
var AsyncEmailOption = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/user-picker/email-option" */'./main').then(function (module) {
    return {
      default: module.EmailOption
    };
  });
});
export default AsyncEmailOption;